<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select class="form-control" v-model="UsuarioId">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un juez</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los jueces</option>
        <option v-for="Juez in Jueces" :value="Juez.UsuarioId">{{Juez.Nombre.toUpperCase()}} {{Juez.ApellidoPaterno.toUpperCase()}} {{Juez.ApellidoMaterno.toUpperCase()}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        Jueces: [],
        UsuarioId: this.tipo.Id
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    methods: {
      cargaCatalogoJueces(usuarioId) {                
        let parametros = {
          EsPrueba: true          
        }
        
        axios.post(api.conexion + api.Cuentas.usuarios.C001Jueces, {
          params: parametros
        })
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.Jueces = respuesta.data.Jueces;
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },      
    },
    created() {
      this.cargaCatalogoJueces();
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Cuentas/Usuarios/001Jueces.vue